import React from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import UpsellChip from '~/Common-Objects/UI/Chips/Upsell.jsx'
import UpsellModal from '~/Common-Objects/UpsellModal'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import { alterFullpage, alterSiteDrawer } from '~/data/actions/siteActions'

export default function TierLimitHolder({
    err = '',
    type = '',
    tierName = '',
    feature = '',
    title = '',
    description = '',
    allowedNumber,
    onUpgrade,
    small = false,
    darkmode = false,
    secondaryButton = null,
    upsell = null,
    inline = false,
    newLayout = false,
    noMarg = false,
    className = '',
    onUpgradeClick = null,
    onUpgradeClickSilently = null,
    extraCta = null,
    buttonClassName = ''
}) {
    const history = useHistory()
    const dispatch = useDispatch()

    const upgrade = () => {
        if (upsell) {
            const modal = (
                <UpsellModal
                    feature={feature}
                    requiredTier={upsell.name}
                    inline={inline}
                    onUpgradeClick={onUpgradeClick}
                    onUpgradeClickSilently={onUpgradeClickSilently}
                    onUpgrade={async () => {
                        dispatch(alterFullpage(null))
                        if (!inline) dispatch(alterSiteDrawer(false, true, 'right', null))
                        if (onUpgrade) {
                            onUpgrade()
                        }
                    }}
                />
            )
            dispatch(alterFullpage(modal))
        } else {
            if (onUpgrade) {
                onUpgrade()
            } else {
                history.push('/cp/company/subscription')
            }
        }
    }

    let classes = 'text-left mar-b25 '
    if (small) classes += 'warning-holder-small'

    let buttonClasses = ''
    if (darkmode) buttonClasses += ' button-darkmode-trans'
    if (buttonClassName) buttonClasses += ' ' + buttonClassName

    if (noMarg) {
        classes = classes.replace('mar-b25', '')
    }

    if (className) classes += ' ' + className

    if (upsell && newLayout) {
        return (
            <WarningHolder className={classes}>
                <UpsellChip className='mar-b12'>{upsell.name}</UpsellChip>
                <div className='mar-b12'>
                    <div
                        style={{
                            fontWeight: 600,
                            fontStyle: 'Semi Bold',
                            fontSize: 16,
                            lineHeight: '20px',
                            letterSpacing: '0px'
                        }}
                    >
                        {title}
                        {!title && (
                            <>
                                Upgrade to {upsell.name} to unlock {type}
                            </>
                        )}
                    </div>
                    {!!description && (
                        <div
                            style={{
                                marginTop: 4,
                                fontWeight: 400,
                                fontSize: 12,
                                lineHeight: '16px',
                                letterSpacing: '-0.1px',
                                color: 'var(--neutral-800)'
                            }}
                        >
                            {description}
                        </div>
                    )}
                </div>
                <div className='quickFlex' style={{ gap: 10, alignItems: 'center' }}>
                    <Button
                        className={'button-sml ' + buttonClasses}
                        onClick={upgrade}
                        text={'Upgrade to ' + upsell.name}
                        postHogTag={feature + '-upsell-button'}
                    />
                    {extraCta}
                </div>
            </WarningHolder>
        )
    }

    if (err == 'tierForbids') {
        return (
            <WarningHolder
                darkmode={darkmode}
                className={classes}
                iconLeft={small ? undefined : <Icons icon='alert' />}
            >
                <h4 className='mar-b15'>Please upgrade to use {type}</h4>
                <div>
                    You are subscribed to the{' '}
                    <SquareChip className='square-chip-green'>{tierName}</SquareChip> tier which does not
                    include {type}.
                </div>
                <div className='mar-b25'>To continue please upgrade your subscription.</div>
                <Button className={buttonClasses} onClick={upgrade} text='Upgrade your Account' />
                {secondaryButton}
            </WarningHolder>
        )
    }

    if (err == 'tierOverLimit') {
        let message = `or delete existing ${type}s.`
        if (type === 'Site Tracker') {
            message = 'or archive existing domains'
        } else if (type === 'Condition Step') {
            message = 'or pause other automations with conditions steps'
        } else if (type === 'AI Lookup') {
            message = 'or wait until your limit resets when you are next billed'
        }
        return (
            <WarningHolder darkmode={darkmode} className={classes} iconLeft={<Icons icon='alert' />}>
                <h4 className='mar-b15'>You have created too many {type}s</h4>
                <div>
                    You are subscribed to the{' '}
                    <SquareChip className='square-chip-green'>{tierName}</SquareChip> tier which allows{' '}
                    <strong>up to {allowedNumber}</strong> {type}s. You have reached this limit.
                </div>
                <div className='mar-b25'>To continue please either upgrade your subscription, {message}</div>
                <Button className={buttonClasses} onClick={upgrade} text='Upgrade your Account' />
                {secondaryButton}
            </WarningHolder>
        )
    }

    return <></>
}
